<template>
  <div :id="`room-scene-viewer-${prefix}`" class="mb-5"></div>
</template>

<script>
export default {
  props: ["productDetail", "prefix", "features"],
  data() {
    return {
      viewerInstance: null,
    };
  },
  mounted() {
    if (this.productDetail && this.productDetail.Has360) {
      this.loadViewer(this.productDetail.ItemNumber, this.prefix);
    }
  },
  watch: {
    features(val) {
      let features = val;
      if (this.viewerInstance && features && features.length) {
        this.viewerInstance.setFeatures(features);
      }
    },
  },
  methods: {
    async loadViewer(itemNumber, prefix) {
      try {
        let customer = 5037;
        let resp = await this.$http.get(
          `https://content.cylindo.com/api/v2/${customer}/products/${prefix}-${itemNumber}/configuration`
        );
        if (resp && resp.status == 200) {
          let productInfo = resp.data;
          this.viewerInstance = null;
          let opts = {
            accountID: productInfo.customer,
            productCode: productInfo.code,
            containerID: `#room-scene-viewer-${prefix}`,
            version: productInfo.version,
            thumbs: false,
          };

          //let features = productInfo.features;
          //this.getMaterials(features);

          if (window.cylindo) {
            window.cylindo.on("ready", () => {
              this.viewerInstance = window.cylindo.viewer.create(opts);
            });
          }
          this.$emit("hasRoomScene", true);
        } else {
          this.$emit("hasRoomScene", false);
        }
      } catch (error) {
        this.$emit("hasRoomScene", false);
      }
    },
  },
};
</script>
